import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SHOPCARDWITHLOGOBLOCK_LEGACY_FIELD_ORDER = [
  "shop",
  { type: 'separator' },
  "display_entity_image",
  "display_entity_category",
  { type: 'separator' },
  "entity_name",
  "entity_category",
  "image"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  shopCardWithLogoBlockDescriptor: _generatedShopCardWithLogoBlockDescriptor,
  shopCardWithLogoBlockBlocDefinition,
  shopCardWithLogoBlockDashboardLayout,
  shopCardWithLogoBlockConfig,
  shopCardWithLogoBlockResolveConfig,
  shopCardWithLogoBlockProperties,
} = doodBlockConfig(
  {
    name: "Shop card with logo",
    componentType: 'ShopCardWithLogoBlockComponent',
    category: 'catalog',
    description: "Shop card with logo.",
    keywords: [],
    allowedIn: [
      { bloc: "ShopCardsBlockComponent", slot: "shops" },
    ],
    sharedFields: {}
  },

  () => ({
    shop: propertyValue({
      type: 'shop_picker',
      value: '',
      options: {
        label: "pages.blocks.shop-card-with-logo.shop.label",
        max: 1
      }
    }),
    display_entity_image: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.shop-card-with-logo.display-entity-image.label",
      }
    }),
    display_entity_category: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.shop-card-with-logo.display-entity-category.label",
        help: "pages.blocks.shop-card-with-logo.display-entity-category.help",
      }
    }),
    entity_name: propertyValue({
      type: 'textarea',
      value: '',
      options: {
        label: "pages.blocks.shop-card-with-logo.entity-name.label",
        help: "pages.blocks.shop-card-with-logo.entity-name.help",
        rows: 2
      }
    }),
    entity_category: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.shop-card-with-logo.entity-category.label",
        help: "pages.blocks.shop-card-with-logo.entity-category.help",
      }
    }),
    image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.shop-card-with-logo.image.label",
        help: "pages.blocks.shop-card-with-logo.image.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.shop-card-with-logo.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.shop-card-with-logo.fieldset.shop.label",
            fields: ["shop"],
          },
          {
            legend: "pages.blocks.shop-card-with-logo.fieldset.name.label",
            fields: ["entity_name"],
          },
          {
            legend: "pages.blocks.shop-card-with-logo.fieldset.category.label",
            fields: [
              "display_entity_category",
              {
                prop: "entity_category",
                visibleWhen: { display_entity_category: true },
              },
            ],
          },
          {
            legend: "pages.blocks.shop-card-with-logo.fieldset.image.label",
            fields: [
              "display_entity_image",
              {
                prop: "image",
                visibleWhen: { display_entity_image: true },
              },
            ],
          },
        ],
      },
    ],
  })
);

export function shopCardWithLogoBlockDescriptor(): IBlockDescriptor;
export function shopCardWithLogoBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function shopCardWithLogoBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedShopCardWithLogoBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedShopCardWithLogoBlockDescriptor, shopCardWithLogoBlockProperties, fieldOrder);
}

export {
  shopCardWithLogoBlockBlocDefinition,
  shopCardWithLogoBlockDashboardLayout,
  shopCardWithLogoBlockProperties,
  shopCardWithLogoBlockConfig,
  shopCardWithLogoBlockResolveConfig,
};

export type ShopCardWithLogoBlockConfig = typeof shopCardWithLogoBlockConfig;
